import dayjs from "dayjs";
import Decimal from "decimal.js";

export interface PrismaTransformerConfig {
  dateFields?: string[];
  dayJsFields?: string[];
  decimalFields?: string[];
  bigIntFields?: string[];
}

const transformProperty = (key: string, value: unknown, config?: PrismaTransformerConfig): unknown => {
  if (config?.dateFields?.includes(key) && typeof value === "string") {
    return new Date(value);
  }
  if (config?.dayJsFields?.includes(key) && typeof value === "string") {
    return dayjs(value);
  }
  if (config?.decimalFields?.includes(key) && typeof value === "string") {
    return new Decimal(value);
  }
  if (config?.bigIntFields?.includes(key) && typeof value === "number") {
    return BigInt(value);
  }
  if (value && typeof value === "object") {
    return transformObject(value, config);
  }
  return value;
};

const transformObject = (obj: unknown, config?: PrismaTransformerConfig): unknown => {
  if (Array.isArray(obj)) {
    return obj.map((item) => transformObject(item, config));
  }

  if (obj && typeof obj === "object") {
    const transformed: Record<string, unknown> = {};

    for (const [ key, value ] of Object.entries(obj)) {
      transformed[key] = transformProperty(key, value, config);
    }

    return transformed;
  }

  return obj;
};

export const createPrismaResponseTransformer = <T = unknown>(
  config?: PrismaTransformerConfig,
) => (data: unknown): T => {
  if (!data || typeof data !== "object") {
    return data as T;
  }

  return transformObject(data, config) as T;
};
